import type { ComponentType } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import type { TranslationType } from '@kiwicom/account-consts';

import type { DateType } from './SimpleDateSelect';
import SimpleDateSelect from './SimpleDateSelect';

type Props = {
  readonly name: string | null | undefined;
  readonly label: TranslationType;
  readonly dataTest?: string;
  readonly errorDataTest?: string;
  readonly disabled?: boolean;
};

const DateField = ({ name, ...rest }: Props) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const value = watch(name) ?? '';
  const [year, month, day] = value.split('-');

  const handleBlur = (field, e) => {
    field.onBlur(e);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SimpleDateSelect
          onBlur={(e) => handleBlur(field, e)}
          year={year}
          month={month}
          day={day}
          onChange={({ day, month, year }: DateType) => {
            const dateStr = `${year}-${month}-${day}`;
            field.onChange(dateStr === '--' ? '' : dateStr);
          }}
          error={errors[name]?.message}
          ref={field.ref}
          {...rest}
        />
      )}
    />
  );
};

export default DateField as ComponentType<Props>;
